<script>
    import { createEventDispatcher } from "svelte";

    export let options = [];
    export let selectedOptionIds = [];
    export let questionImages = [];

    const dispatch = createEventDispatcher();

    let imageContainer = null;

    function getRelativePos(event) {
        const rect = imageContainer.getBoundingClientRect();
        return {
            x: Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100)),
            y: Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100)),
        };
    }

    function handleClick(event) {
        const { x, y } = getRelativePos(event);

        // Trouver la zone cliquée (la plus petite si plusieurs se chevauchent)
        const hit = options
            .filter(opt => {
                const z = opt.hotspotZone;
                if (!z) return false;
                return x >= z.x && x <= z.x + z.w && y >= z.y && y <= z.y + z.h;
            })
            .sort((a, b) => (a.hotspotZone.w * a.hotspotZone.h) - (b.hotspotZone.w * b.hotspotZone.h))[0];

        if (hit) {
            dispatch("select", { optionId: hit.serverId });
        }
    }

    $: image = questionImages?.[0] ?? null;
</script>

<div class="hotspot-wrapper">
    {#if image}
        <div
            class="image-container"
            bind:this={imageContainer}
            on:click={handleClick}
            role="button"
            tabindex="0"
            on:keydown={(e) => e.key === 'Enter' && handleClick(e)}
        >
            <img
                src={image.urlCachePWA || image.url}
                alt="Image hotspot"
                class="hotspot-image"
                on:error={(e) => { e.target.src = image.url; }}
                draggable="false"
            />

            {#each options as option}
                {#if option.hotspotZone}
                    {@const z = option.hotspotZone}
                    {@const isSelected = selectedOptionIds.includes(option.serverId)}
                    <div
                        class="zone {isSelected ? 'selected' : ''}"
                        style="left:{z.x}%; top:{z.y}%; width:{z.w}%; height:{z.h}%"
                    ></div>
                {/if}
            {/each}
        </div>
        <p class="hint text-base-content/60">Cliquez sur une ou plusieurs zones dans l'image.</p>
    {:else}
        <p class="text-base-content/60">Aucune image disponible pour cette question.</p>
    {/if}
</div>

<style>
    .hotspot-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
    }

    .image-container {
        position: relative;
        display: inline-block;
        cursor: crosshair;
        user-select: none;
        border-radius: 8px;
        overflow: hidden;
        width: 100%;
    }

    .hotspot-image {
        display: block;
        width: 100%;
        height: auto;
        pointer-events: none;
    }

    .zone {
        position: absolute;
        border: 2px solid rgba(99, 102, 241, 0.8);
        border-radius: 4px;
        background: rgba(99, 102, 241, 0.15);
        transition: background 0.15s, border-color 0.15s, border-style 0.15s;
        cursor: pointer;
    }

    .zone:hover {
        background: rgba(99, 102, 241, 0.15);
        border-color: rgba(99, 102, 241, 0.8);
    }

    .zone.selected {
        background: rgba(99, 102, 241, 0.75);
        border: 3px solid rgba(99, 102, 241, 1);
        box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.4);
    }

    .hint {
        font-size: 0.85rem;
        text-align: center;
        margin: 0;
    }
</style>
